import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import GoogleService from 'services/providers/GoogleService';

const GoogleAdsAuthorize = props => {
    const [authUrl, setAuthUrl] = useState('');
    const history = useHistory();

    const getData = async () => {
        const r = await GoogleService.getAuthUrl();

        if (r?.success && r?.url) {
            setAuthUrl(r.url);
        } else {
            alert("Google authorization failed.");
        }
    };

    useEffect(() => {
        if (authUrl) {
            window.location.href = authUrl;
        }
    }, [authUrl]);

    useEffect(async () => {
        await getData();
    }, []);

    return <></>;
};

export default GoogleAdsAuthorize;
